var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body main-font"},[(_vm.isKnownStakeType)?_c('staking',{staticClass:"staking",attrs:{"stakeType":_vm.stakeType}}):_c('h1',[_vm._v("Unknown stake type, please try again.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }